import { render, staticRenderFns } from "./AbroadChangguanList.vue?vue&type=template&id=a97eb55c&scoped=true"
import script from "./AbroadChangguanList.vue?vue&type=script&lang=js"
export * from "./AbroadChangguanList.vue?vue&type=script&lang=js"
import style0 from "./AbroadChangguanList.vue?vue&type=style&index=0&id=a97eb55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97eb55c",
  null
  
)

export default component.exports